import { styled } from '@mui/material'
import { Box } from '@mui/system'

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: theme.spacing(1),
}))
